import { render, staticRenderFns } from "./IndustryIcon.vue?vue&type=template&id=24b35839&"
import script from "./IndustryIcon.vue?vue&type=script&lang=js&"
export * from "./IndustryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports